export type TabName = 'forms' | 'tables' | 'trade' | 'notifications' | 'search'

export const TAB_TITLES: Record<TabName, string> = {
  forms: '表单',
  tables: '表格',
  trade: '收款',
  notifications: '通知',
  search: '搜索',
}
